export const INITIAL_STATE = {
  isLogin: false,
};

export const login = (state, action) => {
  return {
    ...state,
    isLogin: true,
  };
};

export const logout = (state, action) => {
  return {
    ...state,
    isLogin: false,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  //   console.log("action", action.type, action);
  switch (action.type) {
    case "LOGIN":
      return login(state, action);
    case "LOGOUT":
      return logout(state, action);
    default:
      return state;
  }
};
